import { Component, OnInit, OnDestroy } from '@angular/core';
import { Query } from './query.model';
import { Subscription } from 'rxjs/Subscription';
import { QueryService } from './query.service';

@Component({
  selector: 'app-haulers',
  templateUrl: './haulers.component.html',
  styleUrls: ['./haulers.component.css']
})
export class HaulersComponent implements OnInit, OnDestroy {
  query: Query;
  subscription: Subscription;

  constructor(private queryService: QueryService) { }

  ngOnInit() {
    this.subscription = this.queryService.queryChanged
      .subscribe(
        (query: Query) => {
          this.query = query;
        });
    this.query = this.queryService.getQuery();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/haulers/haulers.component.ts